import { AxiosInstance, AxiosStatic } from 'axios'
import { ApiRoutesNames } from 'bets.oddprovider.lib.common.ts/api/routes'
import { ICompanyGroup } from 'bets.oddprovider.lib.common.ts/models'
import { BaseApiClient } from 'fwork-jsts-common/src/apiClient'
import { WhereOptions } from 'sequelize'
import { store } from '../redux/store'

export class CompaniesGroupsApiClient extends BaseApiClient<ICompanyGroup, any, WhereOptions<ICompanyGroup>, ICompanyGroup, ICompanyGroup> {
  constructor(axios: AxiosStatic | AxiosInstance) {
    const dotEnvProductionState = store.getState().dotEnvProductionState
    const baseUrl = `${dotEnvProductionState.payload?.APIURL}${ApiRoutesNames.companiesGroups}`
    super({
      apiUrl: baseUrl,
      axios,
    })
  }
}